import {db} from '../firebase'
import {collection, getDocs, query, where} from "firebase/firestore"

async function getProductById(id) {

    try{              
    const dataRef = collection(db, "productos");
    const q = query(
                    dataRef,
                    where("id", "==", `${id}`)
    );
    const querySnapshot = await getDocs(q)
    const dataDB = querySnapshot.docs.map((doc) => doc.data());
        
//     querySnapshot.forEach((doc) => {
//      // doc.data() is never undefined for query doc snapshots
//      console.log(doc.id, " => ", doc.data());
//    });

   //console.log(dataDB)
   return dataDB

} catch (error) {
    console.log(error)  
}}
export default getProductById;